// The resource checks assign() runs before it builds a write: the shutoff gate, which refuses, then
// the ceiling pre-flight, which only warns. Pure so the rules can be tested without the hook;
// assign() shows `notification` when there is one and stops when `proceed` is false.

import { isResourceAcceptingBookings } from '../planningDerivations';
import { isBookedOnResourceDay, isDeliveryLeg } from './ordersOffResource';
import { advisoryLines, asEntry, checkRouteCeilings, shutoffMessage } from './resourceCeilings';

export const preflightAssign = ({ route, resource, ordersToAdd, tz }) => {
    // Per order, not per route: closing a day stops new work landing on it, not the day running, so
    // only an order not already booked on this resource-day is refused. Pickup legs never write
    // resource_id, so they never book one.
    if (!isResourceAcceptingBookings(resource, route?.scheduled_delivery, tz)) {
        const newBookings = ordersToAdd.filter((order) => isDeliveryLeg(order) && !isBookedOnResourceDay(order, route));

        if (newBookings.length > 0) {
            return {
                proceed: false,
                notification: { severity: 'warning', message: shutoffMessage(route) },
            };
        }
    }

    // Nothing downstream refuses a route over a resource ceiling, so this never blocks.
    const { advisory } = checkRouteCeilings(route, ordersToAdd);
    if (advisory.length > 0) {
        return {
            proceed: true,
            notification: { severity: 'warning', message: advisoryLines(asEntry({ route, advisory })) },
        };
    }

    return { proceed: true, notification: null };
};
